import React, { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '@/shared/lib/@deprecated/iport-icons/template/IconTemplateIPortIcon'
import { CustomIconProps } from '@/shared/ui/icon-template'

export const SvgSBP = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon height={50} width={53} {...props}>
			<svg viewBox="0 0 53 34" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M52.0141 12.9888V20.1137H49.4661V15.1157H47.0128V20.1137H44.4648V12.9883H52.0141V12.9888Z"
					fill="black"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M39.234 20.3683C41.5149 20.3683 43.2087 18.9719 43.2087 16.8549C43.2087 14.8059 41.959 13.4756 39.8705 13.4756C38.9067 13.4756 38.1113 13.8143 37.5123 14.3989C37.6553 13.1907 38.6785 12.3086 39.8051 12.3086C40.0651 12.3086 42.0225 12.3045 42.0225 12.3045L43.1294 10.1895C43.1294 10.1895 40.6719 10.2453 39.5295 10.2453C36.9193 10.2907 35.1562 12.6598 35.1562 15.5372C35.1562 18.8893 36.8758 20.3683 39.234 20.3683ZM39.2479 15.349C40.0948 15.349 40.6819 15.9046 40.6819 16.8547C40.6819 17.7098 40.1602 18.4143 39.2479 18.4162C38.3752 18.4162 37.7881 17.7634 37.7881 16.8692C37.7881 15.9189 38.3752 15.349 39.2479 15.349Z"
					fill="black"
				/>
				<path
					d="M33.0786 17.7295C33.0786 17.7295 32.4769 18.0758 31.5782 18.1413C30.545 18.1719 29.6244 17.5204 29.6244 16.3627C29.6244 15.2334 30.4368 14.5862 31.5522 14.5862C32.2361 14.5862 33.1409 15.0595 33.1409 15.0595C33.1409 15.0595 33.8029 13.8464 34.1459 13.2398C33.5179 12.7645 32.6814 12.5039 31.7086 12.5039C29.2533 12.5039 27.3516 14.1024 27.3516 16.3483C27.3516 18.6229 29.139 20.1843 31.7086 20.1371C32.4268 20.1104 33.4177 19.8586 34.0216 19.4712L33.0786 17.7295Z"
					fill="black"
				/>
				<path d="M0 7.96289L3.53444 14.2711V18.1189L0.0041347 24.4148L0 7.96289Z" fill="#5B57A2" />
				<path d="M13.5742 11.9746L16.8861 9.94772L23.6641 9.94141L13.5742 16.1134V11.9746Z" fill="#D90751" />
				<path d="M13.5513 7.92541L13.5701 16.2773L10.0273 14.1037V1.61914L13.5516 7.92541H13.5513Z" fill="#FAB718" />
				<path
					d="M23.6599 9.9421L16.8817 9.94841L13.5513 7.92541L10.0273 1.61914L23.6597 9.9421H23.6599Z"
					fill="#ED6F26"
				/>
				<path d="M13.5701 24.45V20.3979L10.0273 18.2656L10.0293 30.7626L13.5701 24.45Z" fill="#63B22F" />
				<path d="M16.8744 22.4413L3.5342 14.2711L0 7.96289L23.6464 22.433L16.8742 22.4413H16.8744Z" fill="#1487C9" />
				<path d="M10.0273 30.7629L13.5676 24.4503L16.8712 22.4419L23.6432 22.4336L10.0273 30.7629Z" fill="#017F36" />
				<path
					d="M0.00390625 24.4151L10.0568 18.2659L6.67707 16.1953L3.53421 18.1192L0.00390625 24.4151Z"
					fill="#984995"
				/>
			</svg>
		</IconTemplateIPortIcon>
	)
}
